import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Container, SelectAntd } from './styles';

export default function Pagination({ children, meta, perPage = null, setPerPage = null, isMobile, ...props }) {
  const { t } = useTranslation();
  const { from, to, total, current_page } = meta;

  return (
    <>
      {total > 0 && (
        <>
          <Container
            {...props}
            showTotal={
              () =>
                `${t('screens:pagination.showing')} ${from} ${t('screens:pagination.to')} ${to} ${t(
                  'screens:pagination.of'
                )} ${total} ${t('screens:pagination.records')}`
              // eslint-disable-next-line react/jsx-curly-newline
            }
            showSizeChanger={false}
            total={total}
            defaultPageSize={perPage}
            size={isMobile ? 'small' : 'default'}
            current={current_page}
          >
            {children}
          </Container>
          {perPage && setPerPage && (
            <SelectAntd
              name="perPage"
              onChange={(value) => {
                setPerPage(value);
              }}
              value={perPage}
              style={{ width: '70px' }}
            >
              <SelectAntd.Option value={10}>10</SelectAntd.Option>
              <SelectAntd.Option value={20}>20</SelectAntd.Option>
              <SelectAntd.Option value={30}>30</SelectAntd.Option>
              <SelectAntd.Option value={40}>40</SelectAntd.Option>
              <SelectAntd.Option value={50}>50</SelectAntd.Option>
              <SelectAntd.Option value={100}>100</SelectAntd.Option>
            </SelectAntd>
          )}
        </>
      )}
    </>
  );
}

Pagination.propTypes = {
  children: PropTypes.node,
  meta: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  perPage: PropTypes.number,
  setPerPage: PropTypes.func.isRequired,
};

Pagination.defaultProps = {
  children: null,
  meta: {
    from: 0,
    to: 0,
    current_page: 1,
    total: 0,
  },
  perPage: 10,
};
